import React from 'react';
import team1 from '../../../images/team-1.jpg';
import team2 from '../../../images/team-2.jpg';
import team3 from '../../../images/team-3.jpg';
import team4 from '../../../images/team-4.jpg';
const TeamMembers = () => {
    return (
        <div>

            <div class="py-20 bg-gray-100">
                <div class="container mx-auto px-6 md:px-12 xl:px-32">
                    <div class="mb-16 text-center">
                        <h1 className='text-center text-primary my-6 text-5xl font-bold banner_text'>Our Team</h1>


                    </div>
                    <div class="grid gap-12 items-center md:grid-cols-4">
                        <div data-aos="flip-left" class="space-y-4 text-center">
                            <img class="w-64 h-64 mx-auto object-cover rounded-xl md:w-40 md:h-40 lg:w-64 lg:h-64"
                                src={team1} alt="woman" loading="lazy" width="640" height="805" />
                            <div>
                                <h4 class="text-2xl">Hentoni Doe</h4>
                                <span class="block text-sm text-gray-500">CEO-Founder</span>
                            </div>
                        </div>
                        <div data-aos="flip-left" class="space-y-4 text-center">
                            <img class="w-64 h-64 mx-auto object-cover rounded-xl md:w-40 md:h-40 lg:w-64 lg:h-64"
                                src={team2} alt="woman" loading="lazy" width="640" height="805" />
                            <div>
                                <h4 class="text-2xl">Ella Maria</h4>
                                <span class="block text-sm text-gray-500">Manager</span>
                            </div>
                        </div>
                        <div data-aos="flip-left" class="space-y-4 text-center">
                            <img class="w-64 h-64 mx-auto object-cover rounded-xl md:w-40 md:h-40 lg:w-64 lg:h-64"
                                src={team3} alt="woman" loading="lazy" width="1000" height="667" />
                            <div>
                                <h4 class="text-2xl">John Smith</h4>
                                <span class="block text-sm text-gray-500">employee</span>
                            </div>
                        </div>
                        <div data-aos="flip-left" class="space-y-4 text-center">
                            <img class="w-64 h-64 mx-auto object-cover rounded-xl md:w-40 md:h-40 lg:w-64 lg:h-64"
                                src={team4} alt="woman" loading="lazy" width="1000" height="667" />
                            <div>
                                <h4 class="text-2xl">Rosie Oliver</h4>
                                <span class="block text-sm text-gray-500">employee</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamMembers;